module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4r3r1r2n-6f3b99a3fb942f168027123add9731b1.svg";